import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { useWizard } from 'react-wizard-primitive';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import commonProps from './common/common-props';
import Logo from './common/logo';
import StepLegend from './common/step-legend';
import OnboardingContext, { reducer, defaultState } from './common/context';
import { get } from '../../services/onboarding-services';

const Wizard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  min-height: 700px;
  justify-content: ${props => (props.theme.isMobile ? 'flex-start' : 'center')};
  align-items: center;
  background: transparent ${props => props.theme.linearGradientLightTheme} no-repeat padding-box;
  padding: 0;

  ${props => (props.theme.isMobile ? `
    justify-content: flex-strat;
    background-color: white;
  ` : `
    justify-content: center;
    background: transparent ${props.theme.linearGradientLightTheme} no-repeat padding-box;

    &:after {
      content: '';
      height: 10vh;
      max-height: 110px;
    }
  `)}
`;

export default function Onboarding(props) {
  const [st, dispatch] = React.useReducer(reducer, defaultState);
  const common = commonProps();

  const {
    previousStep, nextStep, activeStepIndex, resetToStep, getStep,
  } = useWizard();

  React.useEffect(() => {
    get().then(result => {
      dispatch({ type: 'setInvestorTypes', payload: result.data.investorTypes });
      dispatch({ type: 'setAssetClasses', payload: result.data.assetClasses });
      dispatch({ type: 'setProductsAvailable', payload: result.data.stockCodes });
    });
  }, []);

  useChangeAwareEffect(({ isMount }) => {
    if (!isMount) {
      return;
    }
    const { investorType, assetClasses } = _.get(window, 'Livewire.currentUser.profile', {});
    let step = 0;
    if (investorType) {
      dispatch({ type: 'setSelectedInvestorType', payload: investorType });
      step = 1;
    }
    if (_.get(assetClasses, 'length')) {
      window.location.replace(props.redirectToUrl);
      return;
    }
    resetToStep(step);
  }, {});

  const stepProps = {
    previousStep, nextStep, redirectToUrl: props.redirectToUrl, features: props.features,
  };

  return (
    <ThemeProvider theme={common}>
      <OnboardingContext.Provider value={{ state: st, dispatch }}>
        <Wizard>
          <Logo source={props.logo} />
          <StepLegend
            steps={common.steps.map(d => d.name)}
            activeStepIndex={activeStepIndex}
          />
          {common.steps.map(d => {
            const { comp: Step, name } = d;
            return getStep().isActive
              ? <Step {...stepProps} key={name} />
              : null;
          })}
        </Wizard>
      </OnboardingContext.Provider>
    </ThemeProvider>

  );
}

Onboarding.propTypes = {
  logo: PropTypes.string.isRequired,
  redirectToUrl: PropTypes.string.isRequired,
  /* eslint-disable-next-line react/require-default-props */
  features: PropTypes.string,
};
